var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{staticStyle:{"width":"100%"},attrs:{"indicator-position":"outside"}},_vm._l(([1]),function(item){return _c('el-carousel-item',{key:item},[_c('div',{staticClass:"banner1",style:({'background-image':'url(/static/slide/0' + item + '.jpg)'})})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09dbe3d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/banner.vue
// module id = null
// module chunks = 